import React from 'react';
import { Accordion } from '@naf-simba/elements-accordion';
import { Checkbox } from '@naf-simba/elements-checkbox';
import { FilterOption } from '@appTypes/carFiltersType';
import { FilterType } from '@appTypes/urlParamsType';
import { AccordionContent } from './CarFilter.styles';

interface CheckboxEvent {
  name: keyof FilterType;
  value: boolean;
}

interface Props {
  title: string;
  options: FilterOption[] | undefined;
  checked: Record<string, boolean> | undefined;
  onChange: (e: CheckboxEvent) => void;
  openByDefault?: boolean;
  // Field on each option used as key, Checkbox name, and checked-map lookup.
  // Defaults to 'name'; brands pass 'value' (its visible label).
  identifierKey?: 'name' | 'value';
}

// Always-accordion filter section. Lives inside CarFilter's "Vis flere filtre"
// container (brands, number of seats, drivetrains).
const SecondaryFilterSection = ({
  title,
  options,
  checked,
  onChange,
  openByDefault,
  identifierKey = 'name',
}: Props) => {
  if (!options || options.length === 0) return null;

  return (
    <Accordion headingLevel={3} title={title} size="medium" defaultOpen={openByDefault}>
      <AccordionContent>
        {options.map((opt) => {
          const id = opt[identifierKey];
          return (
            <Checkbox
              key={id}
              onChange={onChange}
              name={id}
              label={`${id} (${opt.count})`}
              checked={checked?.[id] ?? false}
            />
          );
        })}
      </AccordionContent>
    </Accordion>
  );
};

export default SecondaryFilterSection;
